import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const customersApi = createApi({
    reducerPath: 'customersApi',
    tagTypes: ['customers'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getCustomers: build.query({
            query: (data) => ({
                url: api.customers.getCustomers(),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
            providesTags: ['customers']
        }),
        getCustomerBookings: build.query({
            query: ({id, onEndReached, ...data}) => ({
                url: api.customers.getCustomerBookings(id),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(
                    ...newItems.filter(
                        newItem => !currentCache.some(item => item.id === newItem.id)
                    )
                );
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
            async onQueryStarted(arg, { queryFulfilled }) {
                try {
                    const {data} = await queryFulfilled
                    if (data.length === 0) {
                        arg.onEndReached?.()
                    }
                } catch {}
            }
        }),
        getCustomerEvents: build.query({
            query: ({id, onEndReached, ...data}) => ({
                url: api.customers.getCustomerEvents(id),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(
                    ...newItems.filter(
                        newItem => !currentCache.some(item => item.id === newItem.id)
                    )
                );
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
            async onQueryStarted(arg, { queryFulfilled }) {
                try {
                    const {data} = await queryFulfilled
                    if (data.length === 0) {
                        arg.onEndReached?.()
                    }
                } catch {}
            }
        }),
        getCustomerSales: build.query({
            query: ({id, onEndReached, ...data}) => ({
                url: api.customers.getCustomerSales(id),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(
                    ...newItems.filter(
                        newItem => !currentCache.some(item => item.id === newItem.id)
                    )
                );
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
            async onQueryStarted(arg, { queryFulfilled }) {
                try {
                    const {data} = await queryFulfilled
                    if (data.length === 0) {
                        arg.onEndReached?.()
                    }
                } catch {}
            }
        }),
        sendGroupMessage: build.mutation({
            query: (data) => ({
                url: api.customers.sendGroupMessage(),
                method: 'POST',
                body: data,
            }),
        }),
        deleteCustomer: build.mutation({
            query: ({id, ...data}) => ({
                url: api.customers.deleteCustomer(id),
                method: 'DELETE',
                body: data
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    dispatch(
                        customersApi.util.updateQueryData('getCustomers', patch, (draft) => {
                            const index = draft.findIndex((customer) => customer.id === patch.id);
                            if (index !== -1) {
                                draft.splice(index, 1)
                            } else {
                                console.warn('Customer not found in cache')
                            }
                        })
                    );
                } catch (e) {
                    console.error('Delete failed:', e)
                }
            },
        }),
        editCustomer: build.mutation({
            query: ({id, ...data}) => ({
                url: api.customers.editCustomer(id),
                method: 'PUT',
                body: data
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const {data} = await queryFulfilled
                    dispatch(
                        customersApi.util.updateQueryData('getCustomers', patch, (draft) => {
                            const index = draft.findIndex((customer) => customer.id === patch.id);
                            if (index !== -1) {
                                draft[index] = {
                                    ...draft[index],
                                    ...data
                                }
                            }
                        })
                    );
                } catch (e) {
                    console.error('Update failed:', e)
                }
            },
        }),
    })
})

export const { useLazyGetCustomersQuery, useLazyGetCustomerBookingsQuery, useLazyGetCustomerSalesQuery, useLazyGetCustomerEventsQuery, useDeleteCustomerMutation, useEditCustomerMutation } = customersApi